import { Box, Grid } from "@mantine/core";
import { capitalizeWords } from "utils/string";
import { OrderInfoViewProps } from "./_types";
import { InfoItemPlain } from "components/ui/InfoItem";

const ClientInfoView: React.FC<OrderInfoViewProps> = ({ order }) => {
    if (!order.client) return null;
    let i = order.client
    return (
        <Box>

            <Grid grow gutter="xs">

                <Grid.Col span={12}>
                    <InfoItemPlain label="Name" value={capitalizeWords(`${i.first_name} ${i.last_name}`)} />
                </Grid.Col>

                <Grid.Col span={12}>
                    <InfoItemPlain label="Email" value={i.email} />
                </Grid.Col>

            </Grid>

        </Box>
    )
}

export default ClientInfoView;